// Need to use the React-specific entry point to import createApi
import type {
  GetListResponseOfWorkflowSimpleResponse,
  GetWorkflowListRequest,
  WorkflowResponse,
} from 'src/api/ProactApiClient';
import {workflowApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const workflowApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getWorkflowList: builder.query<
      GetListResponseOfWorkflowSimpleResponse,
      GetWorkflowListRequest
    >({
      queryFn: clientQuery(params => workflowApiClient.list(params)),
      providesTags: ['Workflows'],
    }),
    getWorkflow: builder.query<WorkflowResponse, number>({
      queryFn: clientQuery(id => workflowApiClient.get(id)),
      providesTags: ['Workflows'],
    }),
    reprocessWorkflow: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => workflowApiClient.reprocess(id)),
      invalidatesTags: ['Workflows'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetWorkflowListQuery,
  useGetWorkflowQuery,
  useReprocessWorkflowMutation,
} = workflowApi;
